import React, { useEffect } from 'react';
import { FaInfo } from 'react-icons/fa';
import { GoPlus } from 'react-icons/go';
import { Button, Label } from 'reactstrap';
import CustomDropdown2 from '../../../../../../components/common/CustomDropDown2';

const PATH_INSTRUCTION = 'Draw a path that connects along all walkable routes; Connect all the pins to the path to enable navigation.'; 

const FieldError = ({ error, touched }) =>
    error && touched ? <div className="text-danger mt-1">{error}</div> : null;

const normalizeOptions = (options) =>{
    let filterItem = options.filter(item => item.category !== "vertical")

    const result = [];

    filterItem.forEach((item) => {
        const hasGroupDetails = item?.type === 2 && Array.isArray(item?.group_details) && item.group_details.length > 0;

        if (hasGroupDetails) {
            item.group_details.forEach((sub) => {
                result.push({
                    pin_id : item?.enc_id,
                    id     : `${item?.enc_id}_${sub?.id}`,
                    value  : `${item?.enc_id}_${sub?.id}`,
                    label  : `${sub?.name} - (${item?.title})${item?.floor_plan ? `  (${item.floor_plan})` : ''}`,
                });
            });
        } else {
            result.push({
                pin_id : item?.enc_id,
                id     : item?.enc_id ?? item?.id,
                value  : item?.enc_id ?? item?.id,
                // label  : item?.title,
                label  : `${item?.title } ${item.floor_plan ? `(${item.floor_plan})` : ''}`,
            });
        }
    });

    return result;
}

const findOption = (options, e) =>{
    let item = e?.pin_id
        ? options.find((item) => item?.enc_id == e?.pin_id)
        : options.find((item) => item?.id == e?.id); 
    return item
} 

const InfoAlert = ({ message }) => (
    <div style={{ marginTop: '4rem' }}>
        <div className="warning-pin-div">
            <div className="d-flex align-items-center justify-content-center mb-2">
                <div className="info-cont">
                    <FaInfo />
                </div>
            </div>
            <div className="text-center">
                <p className="label color-labels">{message}</p>
            </div>
        </div>
    </div>
); 

const StepControls = ({ segmentIndex, totalSegments, onStep, onPrevious, onEnd }) => {
    const isAtEnd = segmentIndex >= totalSegments - 1;

    return (
        <div className="d-flex float-right">
            {segmentIndex > 0 && (
                <Button
                    className="btn-primary bar-btn mt-1 mb-3 mr-2"
                    type="button"
                    size="medium"
                    onClick={onPrevious}
                >
                    Previous
                </Button>
            )}
            {!isAtEnd ? (
                <Button
                    className="btn-primary bar-btn mt-1 mb-3"
                    type="button"
                    size="medium"
                    onClick={onStep}
                >
                    Next
                </Button>
            ) : (
                <Button
                    className="btn-danger btn-danger-btn bar-btn mt-1 mb-3"
                    type="button"
                    size="medium"
                    onClick={onEnd}
                >
                    End direction
                </Button>
            )}
        </div>
    );
};
 
const formatDistance = (metres) => {
    if (metres == null) return '';
    if (metres >= 1000) return `${(metres / 1000).toFixed(2)} km`;
    return `${Math.round(metres)} m`;
};
 
const formatWalkTime = (metres) => {
    if (metres == null) return '';
    const totalSeconds = metres / 1.3889;
    const totalMinutes = Math.ceil(totalSeconds / 60);
    if (totalMinutes < 1) return '< 1 min';
    if (totalMinutes < 60) return `${totalMinutes} min`;
    const hours = Math.floor(totalMinutes / 60);
    const mins  = totalMinutes % 60;
    return mins > 0 ? `${hours} hr ${mins} min` : `${hours} hr`;
};

const NavigationTestForm = ({
    errors,
    touched,
    setFieldValue,
    options,
    selTraversibleDetails,
    setSelTraversibleDetails,
    findPath,
    onClear,
    pathResult,
    pathError,
    segmentIndex,
    onStep,
    onPrevious,
    onEnd,
}) => {
    const normalizedOptions = normalizeOptions(options);
    const pathFound      = segmentIndex !== null && pathResult;
    const totalSegments  = pathResult?.segments?.length ?? 1;

    const handleFromChange = (e) => {
        const found = findOption(options, e);
        setSelTraversibleDetails((prev) => ({
            ...prev,
            from:          `${found?.title}_${found?.enc_id}`,
            from_floor_id: found?.fp_id,
            from_pin_id:   found?.enc_id,
            is_miltiple:   false,
            isNext:        0,
        }));
        onClear()
    };

    const handleToChange = (e) => {
        const found = findOption(options, e);
        setSelTraversibleDetails((prev) => ({
            ...prev,
            to:          `${found?.title}_${found?.enc_id}`,
            to_floor_id: found?.fp_id,
            to_pin_id:   found?.enc_id,
            is_miltiple: false,
            isNext:      0,
        }));
        onClear()
    };

    useEffect(() => { 
      return () => {
        onEnd()
      }
    }, [])

    

    return (
        <div>
            <div className="bar-sub-header" style={{ marginTop: 0 }}>
                <p style={{ marginTop: 0 }}>Navigation Path Test</p>
            </div>

            <div className="">
                 
                <div className="marginBottom">
                    <Label className="form-labels">From</Label>
                    <CustomDropdown2
                        name="from"
                        id="from"
                        options={normalizedOptions}
                        setFieldValue={setFieldValue}
                        values={selTraversibleDetails}
                        setCustomerValues={{}}
                        selectValue={{}}
                        onChange={handleFromChange}
                    />
                    <FieldError error={errors.from} touched={touched.from} />
                </div>
 
                <div className="marginBottom">
                    <Label className="form-labels">To</Label>
                    <CustomDropdown2
                        name="to"
                        id="to"
                        options={normalizedOptions}
                        setFieldValue={setFieldValue}
                        values={selTraversibleDetails}
                        setCustomerValues={{}}
                        selectValue={{}}
                        onChange={handleToChange}
                    />
                    <FieldError error={errors.to} touched={touched.to} />
                </div>
 
                {!pathFound ? (
                    <Button
                        className="btn-primary bar-btn float-right mt-1 mb-3"
                        type="button"
                        size="medium"
                        onClick={findPath}
                    >
                        Find
                    </Button>
                ) : pathResult?.isMultiFloor ? (
                    <StepControls
                        segmentIndex={segmentIndex}
                        totalSegments={totalSegments}
                        onStep={onStep}
                        onPrevious={onPrevious}
                        onEnd={onEnd}
                    />
                ) : (
                    <Button
                        className="btn-danger btn-danger-btn bar-btn float-right mt-1 mb-3"
                        type="button"
                        size="medium"
                        onClick={onEnd}
                    >
                        End direction
                    </Button>
                )}

                {pathError && (
                    <div className="text-danger mt-2" style={{ clear: 'both', fontSize: '0.85rem' }}>
                        {pathError}
                    </div>
                )}
 
                {pathResult && !pathError && (
                    <div style={{ clear: 'both', marginTop: '0.75rem' }}>
                        <div
                            style={{
                                background:   '#e8f5e9',
                                border:       '1px solid #66bb6a',
                                borderRadius: 6,
                                padding:      '10px 12px',
                                fontSize:     '0.85rem',
                                color:        '#2e7d32',
                            }}
                        >
                            <div style={{ fontWeight: 600, marginBottom: 4 }}>Path found</div>
                            <div> Distance: <strong>{formatDistance(pathResult.distanceM)}</strong></div>
                            <div> Est. walk time: <strong>{formatWalkTime(pathResult.distanceM)}</strong></div>
                            {pathResult.isMultiFloor && pathResult.segments && (
                                <div style={{ marginTop: 6, paddingTop: 6, borderTop: '1px solid #a5d6a7' }}>
                                    <div style={{ fontWeight: 600, marginBottom: 3 }}> Floor route:</div>
                                    <div>
                                        {pathResult.segments.map((seg, i) => (
                                            <span key={seg.floorId} >
                                                {i > 0 && (
                                                    <span style={{ display:"inline-block",margin:"4px", color: '#1b5e20' }}>↑ vertical transport ↑</span>
                                                )}
                                                <span style={{
                                                    display:      'inline-block',
                                                    background:   i === segmentIndex ? '#66bb6a' : '#c8e6c9',
                                                    borderRadius: 4,
                                                    padding:      '1px 6px',
                                                    fontWeight:   600,
                                                    color:        i === segmentIndex ? '#fff' : 'inherit',
                                                }}>
                                                    {seg.floorName}
                                                </span>
                                                {i < pathResult.segments.length - 1 && <br />}
                                            </span>
                                        ))}
                                    </div>
                                    <div style={{ marginTop: 4, fontSize: '0.78rem', color: '#388e3c' }}>
                                        Use Next / Previous to navigate between floors.
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* <Button
                            className="btn-danger bar-btn mt-2"
                            type="button"
                            size="sm"
                            style={{ width: '100%' }}
                            onClick={onEnd}
                        >
                            Clear
                        </Button> */}
                    </div>
                )}
            </div>

            <InfoAlert message={PATH_INSTRUCTION} />
        </div>
    );
};

const NavigationFormFields = ({
    errors,
    touched,
    setFieldValue,

    options,
    selTraversibleDetails,
    setSelTraversibleDetails,

    findPath,
    onClear,
    pathResult,
    pathError,
    segmentIndex,
    onStep,
    onPrevious,
    onEnd,
}) => {

    return (
        <NavigationTestForm
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            options={options}
            selTraversibleDetails={selTraversibleDetails}
            setSelTraversibleDetails={setSelTraversibleDetails}
            findPath={findPath}
            onClear={onClear}
            pathResult={pathResult}
            pathError={pathError}
            segmentIndex={segmentIndex}
            onStep={onStep}
            onPrevious={onPrevious}
            onEnd={onEnd}
        />
    );
};

export default NavigationFormFields;